import UnAuthConnection from '@/communication/UnAuthConnection'

export default async function ({ commit }, {username = null, password = null}) {
  if (!username || !password) {
    return Promise.reject(new Error('User or Password error'))
  }

  const payload = await UnAuthConnection.post(`/authenticate`, { username, password })
    .catch((err) => {
      return Promise.reject(err)
    })

  commit('SET_LOGIN_INFO', payload.data)
  window.localStorage.setItem('token', payload.data.token)
  window.localStorage.setItem('username', username)
  window.localStorage.setItem('userId', payload.data.userId)
  window.localStorage.setItem('permissions', JSON.stringify(payload.data.permission))

  return Promise.resolve()
}



// WEBPACK FOOTER //
// ./src/view/login/state/action/DoLogin.js